module.exports = __webpack_public_path__ + "img/azg_反白 1@2x.bd0202b9.png";